// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "app.zeal",
    name: "Zeal",
    homepage: "https://www.zeal.app/",
    image_id: "5416fb0b-9aec-4ffe-b7cd-c04c79ea4300",
    app: {
        browser: null,
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chrome.google.com/webstore/detail/zeal-wallet/heamnjbnflcikcggoiplibfommfbkjpj?hl=en&authuser=0",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "app.zeal",
    mobile: {
        native: "zeal://walletconnect/",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map